import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { BaseHttpService } from '../../base/_base-http.service';
import { Config } from '../../config/env.config';
import { prepareGroupedFieldsList } from '../../search/search-helpers';
import { USER_ATTR_OPT } from '../part-attributes-search/attribute-options';
import {catchError, map} from 'rxjs/operators';


@Injectable()
export class AdvancedSearchService extends BaseHttpService {

  fetchFieldsList(status: string, brandId?: string, itemId?: string, listId?: string): Observable<any> {
    let queryString = `status=${status}`;
    if (brandId) {
      queryString += `&brandRelationshipId=${brandId}`;
    }
    if (itemId && listId) {
     queryString += `&id=${itemId}`;
     queryString += `&item=${listId}`;
    }
    const requestString = `${Config.API}/advance-search-attributes/fields-list?${queryString}`;

    return this.http.get(requestString)

      .pipe(catchError(this.handleError.bind(this)));
  }

  fetchOptionsFieldsList(status: string, brandId?: string, itemId?: string, listId?: string): Observable<any> {
    return this.fetchFieldsList(status, brandId, itemId, listId)
      .pipe(map((res: any) => {
        return _.map(_.values(res), (item: any) => {
          item.option = item.attribute_name;
          return item;
        });
      }));
  }

  // get options for certain attribute
  fetchAttributeOptions(status: string, brandId: string, attributeName: string, selectedFilters?: any): Observable<any> {

    let queryString = '';
    if (_.isArray(selectedFilters)) {
      queryString = selectedFilters ?
        selectedFilters.map((filter: any) => {
          return `${filter.name}=${filter.value}`;
        }).join('&') : null;
    } else {
      queryString = _.reduce(selectedFilters, (result: string, filterValue: any, key: string) => {
        if (_.isArray(filterValue)) {
          return _.reduce(filterValue, (memo: string, value: any) => {
            return `${memo}${!memo ? '' : '&'}${key}[]=${value}`;
          }, result);
        } else {
          if (attributeName === USER_ATTR_OPT) {
            return `${result}${!result ? '' : '&'}filter[${attributeName}_${key}]=${filterValue || ''}`;
          }
          return `${result}${!result ? '' : '&'}${key}=${filterValue || ''}`;
        }
      }, '');
    }

    const requestString = `${Config.API}/advance-search/${brandId}/${status}/${attributeName}${queryString ? '?' + queryString : ''}`;

    return this.http.get(requestString)

      .pipe(catchError(this.handleError.bind(this)));
  }

  fetchProductGroupedFieldsList(brandId: any, itemName: any, productId: any): Observable<any> {
    return this.http.get(`${Config.API}/advance-search-attributes/grouped-fields-list?` +
      `brandRelationshipId=${brandId}` +
      `&item=${itemName}` +
      `&id=${productId}`
    )

      .pipe(map((res: any) => {
        return prepareGroupedFieldsList(res);
      }), catchError(this.handleError.bind(this)));
  }

  fetchGroupedFieldsList(status?: any, brandId?: any): Observable<any> {
    return this.http.get(`${Config.API}/advance-search-attributes/grouped-fields-list` +
      (status ? `?status=${status}` : '') +
      (brandId ? `&brandRelationshipId=${brandId}` : '')
    )

      .pipe(map((res: any) => {
        return prepareGroupedFieldsList(res);
      }), catchError(this.handleError.bind(this)));
  }
}
